import React from 'react';
import { getHelpCenterUrl } from 'util/url';
import errorImg from 'assets/images/search-modal-error.svg';
import { useIntl } from 'react-intl-next';
import { ThemedLink } from 'view/common/themed-link';
import { Root, Img, MessageTitle, HelperText } from '../common';
import messages from './messages';

const SearchResultError = () => {
    const { formatMessage } = useIntl();

    return (
        <Root>
            <Img src={errorImg} />
            <MessageTitle>{formatMessage(messages.searchErrorTitle)}</MessageTitle>
            <HelperText>
                {formatMessage(messages.searchErrorText, {
                    helpCenterLink: (
                        <ThemedLink to={getHelpCenterUrl()} actionSubjectId="helpCenterLink">
                            {formatMessage(messages.helpCenter)}
                        </ThemedLink>
                    ),
                })}
            </HelperText>
        </Root>
    );
};

export default SearchResultError;
